import React from "react"
import MoneyMattersIcon from "./money-matters"
import NewsroomIcon from "./newsroom"
import PawIcon from "./paw"
import PogIcon from "./pog"
import ProgramStoriesIcon from "./program-stories"
import StudentLifeIcon from "./student-life"
import WorkExperienceIcon from "./work-experience"

interface IBlogCategoryIconProps {
  slug: string
  className: string
}

export default function BlogCategoryIcon(
  props: IBlogCategoryLinksProps
): JSX.Element {
  switch (props.slug) {
    case `people-of-georgian`:
      return <PogIcon className={props.className} />
    case `newsroom`:
      return <NewsroomIcon className={props.className} />
    case `student-life`:
      return <StudentLifeIcon className={props.className} />
    case `money-matters`:
      return <MoneyMattersIcon className={props.className} />
    case `program-stories`:
      return <ProgramStoriesIcon className={props.className} />
    case `work-experience`:
      return <WorkExperienceIcon className={props.className} />
    default:
      return <PawIcon className={props.className} />
  }
}
